// @flow
import styled from 'styled-components';

import { SPACING_MEDIUM } from 'styles/spacing';
import { LAYOUT_MAX_WIDTH } from 'styles/widths';

const Container = styled.div`
  ${LAYOUT_MAX_WIDTH};
  display: block;
  margin: 0 auto;
  padding: 0 ${SPACING_MEDIUM};
  width: 100%;
  text-align: left;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/shared/layout/index.js